import { useState } from "react";
import { Link } from "react-router-dom";
import { BiError } from "react-icons/bi";
import { Label, TextInput, Button, Alert } from "flowbite-react";
import { Helmet } from "react-helmet-async";
import "./styles.scss";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  // Função para enviar email de redefinição de senha
  async function sendResetEmail() {
    if (!email || !email.includes('@')) {
      setErrorMessage("Por favor, digite um email válido");
      return;
    }

    try {
      setLoading(true);
      setErrorMessage("");
      
      const { sendEmail: sendEmailService } = await import('../../../services/send-email.service');

      const emailPayload = {
        from: 'noreply@funifier.com',
        to: email,
        subject: 'Redefinição de senha - Rankifier',
        html: `
          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; background-color: #f9fafb; padding: 20px;">
            <div style="background-color: white; padding: 30px; border-radius: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
              <h2 style="color: #8B5CF6; margin-bottom: 20px;">Redefinição de senha</h2>
              
              <p style="color: #374151; line-height: 1.6; margin-bottom: 15px;">
                Olá,
              </p>
              
              <p style="color: #374151; line-height: 1.6; margin-bottom: 20px;">
                Recebemos uma solicitação para redefinir a senha da sua conta no Rankifier.
              </p>
              
              <p style="color: #374151; line-height: 1.6; margin-bottom: 25px;">
                Clique no botão abaixo para criar uma nova senha:
              </p>
              
              <div style="text-align: center; margin: 30px 0;">
                <a href="https://rankifier.funifier.com/nova-senha?email=${encodeURIComponent(email)}" 
                   style="background-color: #8B5CF6; color: white; padding: 12px 30px; text-decoration: none; border-radius: 6px; display: inline-block; font-weight: bold;">
                  Redefinir Senha
                </a>
              </div>
              
              <p style="color: #6B7280; font-size: 14px; margin-top: 30px;">
                Se você não conseguir clicar no botão, copie e cole este link no seu navegador:<br>
                <span style="word-break: break-all;">https://rankifier.funifier.com/nova-senha?email=${encodeURIComponent(email)}</span>
              </p>
              
              <p style="color: #6B7280; font-size: 14px; margin-top: 15px;">
                Se você não solicitou esta redefinição, pode ignorar este email com segurança.
              </p>
              
              <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 20px 0;">
              
              <p style="color: #9CA3AF; font-size: 12px; text-align: center;">
                © 2025 Rankifier - Todos os direitos reservados.
              </p>
            </div>
          </div>
        `
      };
      
      console.log('Enviando email de redefinição:', emailPayload);
      
      const result = await sendEmailService(emailPayload);
      
      console.log('Email enviado com sucesso:', result);
      
      setEmailSent(true);
      
    } catch (error) {
      console.error('Erro ao enviar email:', error);
      setErrorMessage('Erro ao enviar email. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  // Handler para o formulário
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    sendResetEmail();
  };

  if (emailSent) {
    return (
      <>
        <Helmet>
          <title>Email Enviado - Rankifier</title>
        </Helmet>
        <div
          id="forgot-wrapper"
          className="w-full min-h-screen flex items-center justify-center"
        >
          <div className="forgot-card">
            <div className="forgot-header">
              <h1 className="forgot-title">Email enviado!</h1>
              <p className="forgot-subtitle">
                Enviamos um link de redefinição de senha para <strong>{email}</strong>.
                Verifique sua caixa de entrada e spam.
              </p>
            </div>
            
            <div className="forgot-footer">
              <Link to="/login" className="back-to-login">
                Voltar ao login
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Recuperar Senha - Rankifier</title>
      </Helmet>
      <div
        id="forgot-wrapper"
        className="w-full min-h-screen flex items-center justify-center"
      >
        <div className="forgot-card">
          <div className="forgot-header">
            <h1 className="forgot-title">Esqueci minha senha</h1>
            <p className="forgot-subtitle">
              Para redefinir sua senha, informe o e-mail cadastrado na sua conta e te enviaremos um link com as instruções.
            </p>
          </div>

          <form className="forgot-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <Label htmlFor="email" className="form-label">Email</Label>
              <TextInput
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                placeholder="perfil123@email.com"
                required
                className="form-input"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrorMessage("");
                }}
              />
            </div>

            {!!errorMessage && (
              <Alert color="failure" icon={BiError}>
                {errorMessage}
              </Alert>
            )}

            <Button
              type="submit"
              disabled={loading || !email}
              className="forgot-button"
            >
              {loading ? "Enviando..." : "Enviar link de redefinição"}
            </Button>

            <div className="forgot-footer">
              <Link to="/login" className="back-to-login">
                Voltar ao login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
